// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1oaOG","footer":"ModalInfo_footer__3uJqh"};